var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticStyle: { "margin-top": "20px" } },
    [
      _c(
        "b-jumbotron",
        {
          attrs: {
            header: "Você recebeu um convite para usar o App Veins Energia.",
            lead: "Use o código abaixo para se cadastrar."
          }
        },
        [
          _c(
            "p",
            { staticStyle: { "font-size": "50px", "margin-bottom": "50px" } },
            [_c("code", [_vm._v(_vm._s(this.getToken()))])]
          ),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "#" } },
            [
              _c("b-img", {
                staticStyle: { width: "200px" },
                attrs: { src: "/images/app-store.png" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "#" } },
            [
              _c("b-img", {
                staticStyle: { width: "200px" },
                attrs: { src: "/images/play-store.png" }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }